

































import AsyncValidator from "async-validator";
import { Prop, Component, Mixins } from "vue-property-decorator";
import Emitter from "@/fit-ui/common/mixins/emitter";
import { getPropByPath, objectAssign } from "@/fit-ui/common/util";

@Component({
  name: "FitFormItem"
})
export default class FitFormItem extends Mixins(Emitter) {
  @Prop({ default: "" }) public label!: string;
  @Prop({ default: "" }) public labelFor!: string;
  @Prop({ default: "" }) public prop!: string;
  @Prop({ default: "middle" }) public textAlign!: string;
  @Prop({ default: "baseline" }) public alignItem!: string;
  @Prop({ default: false }) public hasPrefixIcon!: boolean;
  @Prop() public initialErrorMsg!: string;
  public validateState = "";
  public validateDisabled = false;
  public validateMessage = this.initialErrorMsg || "";
  public labelWidth = 0;
  get form() {
    let parent = this.$parent;
    let parentName = parent.$options.name;
    while (parentName !== "FitForm") {
      parent = parent.$parent;
      parentName = parent.$options.name;
    }
    return parent;
  }
  get fieldValue() {
    // @ts-ignore
    const model = this.form.model;
    if (!model || !this.prop) {
      return;
    }

    let path = this.prop;
    if (path.indexOf(":") !== -1) {
      path = path.replace(/:/, ".");
    }

    return getPropByPath(model, path, true).v;
  }
  public mounted() {
    this.notify("addField", [this]);
    if (this.prop) {
      let initialValue = this.fieldValue;
      if (Array.isArray(initialValue)) {
        // @ts-ignore
        initialValue = [].concat(initialValue);
      }
      Object.defineProperty(this, "initialValue", {
        value: initialValue
      });

      this.addValidateEvents();
    }
  }
  public getRules() {
    // @ts-ignore
    let formRules = this.form.rules;

    const prop = getPropByPath(formRules, this.prop || "");
    formRules = formRules ? prop.o[this.prop || ""] || prop.v : [];

    return formRules ? [].concat(formRules) : [];
  }
  public getFilteredRule(trigger) {
    const rules = this.getRules();

    return rules
      .filter((rule: any) => {
        if (!rule.trigger || trigger === "") {
          return true;
        }
        if (Array.isArray(rule.trigger)) {
          return rule.trigger.indexOf(trigger) > -1;
        } else {
          return rule.trigger === trigger;
        }
      })
      .map(rule => objectAssign({}, rule));
  }
  public validate(trigger, callback = (...arg) => {}) {
    this.validateDisabled = false;
    const rules = this.getFilteredRule(trigger);
    if (!rules || rules.length === 0) {
      callback();
      return true;
    }

    this.validateState = "validating";

    const descriptor = {};
    if (rules && rules.length > 0) {
      rules.forEach(rule => {
        delete rule.trigger;
      });
    }
    descriptor[this.prop] = rules;

    const validator = new AsyncValidator(descriptor);
    const model = {};

    model[this.prop] = this.fieldValue;

    validator.validate(
      model,
      { firstFields: true },
      (errors, invalidFields) => {
        this.validateState = !errors ? "success" : "error";
        this.validateMessage = errors ? errors[0].message : "";

        callback(this.validateMessage, invalidFields);
        // this.elForm && this.elForm.$emit('validate', this.prop, !errors, this.validateMessage || null);
      }
    );
  }
  public onFieldBlur() {
    this.validate("blur");
  }
  public onFieldChange() {
    if (this.validateDisabled) {
      this.validateDisabled = false;
      return;
    }

    this.validate("change");
  }
  public addValidateEvents() {
    const rules = this.getRules();

    if (rules.length) {
      this.$on("form.blur", this.onFieldBlur);
      this.$on("form.change", this.onFieldChange);
    }
  }
  // 获取标签长度
  public getLabelWidth() {
    if (!this.$refs.label) {
      return 0;
    }
    // @ts-ignore
    return parseInt(window.getComputedStyle(this.$refs.label).width, 10);
  }
  public setLabelWidth(width: number) {
    this.labelWidth = width;
  }
  public notify(trigger, val) {
    this.dispatch("FitForm", `form.${trigger}`, val);
  }
  public beforeDestroy() {
    this.notify("removeField", [this]);
  }
}
